import { FC } from "react";
import { Box } from "@otrium/core";
import { ColorFilterCheckboxOzon } from "src/molecules/ColorFilterCheckbox";
import { useFilterApplied } from "src/organisms/AlgoliaProductList/useFilterApplied";
import { HitType } from "src/types/Algolia";
import {
  FilterContentWrapper,
  OutsideClickableWrapper,
  ScrollWrapper,
} from "src/organisms/AlgoliaProductList/DesktopFilterVeiw/DesktopFilter.styled";
import { ShowResults } from "src/organisms/AlgoliaProductList/DesktopFilterVeiw/ShowResults";

interface Props {
  items: HitType[];
  refine: (value: string[]) => void;
  outerRef: React.RefObject<HTMLDivElement>;
  onClose: () => void;
}

const ColorFilter: FC<Props> = ({ items, refine, onClose, outerRef }) => {
  const { filterApplied, handleRefine } = useFilterApplied(items, refine);
  const multicolorIconLink =
    "https://colors-icons.s3.eu-central-1.amazonaws.com/multicoloured.png";
  return (
    <OutsideClickableWrapper handler={onClose} outerRef={outerRef}>
      <ScrollWrapper>
        <FilterContentWrapper as="ul">
          {items.map((item) => {
            const splitLabel = item.label.split("||");
            const id = splitLabel[0];
            const label = splitLabel[1];
            const color = splitLabel[2];
            return (
              <Box as="li" key={`color-filter-item-${id}`}>
                <ColorFilterCheckboxOzon
                  id={id}
                  checked={item.isRefined}
                  onChange={handleRefine(item.value)}
                  icon={color ? undefined : multicolorIconLink}
                  name={label}
                  hex={color}
                />
              </Box>
            );
          })}
        </FilterContentWrapper>
      </ScrollWrapper>

      <ShowResults hasFilters={filterApplied} onClick={onClose} />
    </OutsideClickableWrapper>
  );
};

export default ColorFilter;
